// External Link Constants
import {
  QUESTIONAIRE_URL,
  THRONE_URL,
  CASH_APP_URL,
  APPLE_PAY_EMAIL,
  VENMO_URL,
  PAYPAL_URL,
  WISHLIST_URL,
  ONLYFANS_URL,
  TWITTER_URL,
  INSTAGRAM_URL,
  SNAPCHAT_URL,
  LOYALFANS_URL,
  TIKTOK_URL,
  YOUPAY_URL,
  SCATBOOK_URL,
  TELEGRAM_URL,
  CompanyEmailAddress,
  ETSY_URL,
} from '../../utils/Constants';
// Icons
import {
  FaPaypal,
  FaTwitter,
  FaInstagram,
  FaSnapchat,
  FaAmazon,
  FaApple,
  FaTiktok,
  FaTelegramPlane,FaEtsy
} from 'react-icons/fa';
import { BsQuestionCircle } from 'react-icons/bs';
import { FaXTwitter } from 'react-icons/fa6';
import { SiVenmo, SiCashapp } from 'react-icons/si';
import { GiStoneThrone } from 'react-icons/gi';
import { MdPayments } from 'react-icons/md';
import { RiScales3Fill } from 'react-icons/ri';
import { MdOutlineEmail } from 'react-icons/md';
// Image icons
import ThroneIcon from '../../assets/images/icons/throne-icon-no-background.png';
import YoupayIcon from '../../assets/images/icons/youpay-icon-no-background.png';

export const linkButtonArray = [
  {
    text: 'Submit Application',
    link: QUESTIONAIRE_URL,
    icon: <BsQuestionCircle />,
  },
  { text: 'LoyalFans', link: LOYALFANS_URL, icon: <FaTiktok /> },
  { text: 'Cash App', link: CASH_APP_URL, icon: <SiCashapp /> },
  { text: 'Apple Pay', link: APPLE_PAY_EMAIL, icon: <FaApple /> },
  { text: 'Venmo', link: VENMO_URL, icon: <SiVenmo /> },
  { text: 'PayPal', link: PAYPAL_URL, icon: <FaPaypal /> },
  { text: 'Amazon Wishlist', link: WISHLIST_URL, icon: <FaAmazon /> },
  { text: 'Throne Wishlist', link: THRONE_URL, icon: <GiStoneThrone /> },
  { text: 'Twitter', link: TWITTER_URL, icon: <FaTwitter /> },
  { text: 'Instagram', link: INSTAGRAM_URL, icon: <FaInstagram /> },
  { text: 'Snapchat', link: SNAPCHAT_URL, icon: <FaSnapchat /> },
  { text: 'TikTok', link: TIKTOK_URL, icon: <FaTiktok /> },
  { text: 'YouPay', link: YOUPAY_URL, icon: <MdPayments /> },
  { text: 'Scatbook', link: SCATBOOK_URL, icon: <RiScales3Fill /> },
  { text: 'Telegram', link: TELEGRAM_URL, icon: <FaTelegramPlane /> },
];

export const payLinkButtonArray = [
  { text: 'Cash App', link: CASH_APP_URL, icon: <SiCashapp /> },
  {
    text: 'Throne',
    link: THRONE_URL,
    icon: (
      <>
        <img src={ThroneIcon} alt='' className='w-6 lg:w-8 -ml-[1px]' />
      </>
    ),
  },
  { text: 'Apple Pay', link: APPLE_PAY_EMAIL, icon: <FaApple /> },
  { text: 'Venmo', link: VENMO_URL, icon: <SiVenmo /> },
  { text: 'PayPal', link: PAYPAL_URL, icon: <FaPaypal /> },
  { text: 'Amazon', link: WISHLIST_URL, icon: <FaAmazon /> },
  { text: 'Etsy', link: ETSY_URL, icon: <FaEtsy /> },
  { text: 'Youpay', link: YOUPAY_URL,     icon: (
    <>
      <img src={YoupayIcon} alt='' className='w-6 lg:w-8 -ml-[1px]' />
    </>
  ), },
];

export const smallSocialMediaPins = [
  {
    serviceName: 'Twitter',
    icon: <FaXTwitter />,
    url: TWITTER_URL,
    background: { background: '#1DA1F2' },
  },
  {
    serviceName: 'Email',
    icon: <MdOutlineEmail />,
    url: `mailto:${CompanyEmailAddress}`,
    background: { background: '#FFFC00' },
  },
  {
    serviceName: 'Cashapp',
    icon: <SiCashapp />,
    url: CASH_APP_URL,
    background: { background: '#000' },
  },
  {
    serviceName: 'Throne',
    icon: (
      <>
        <img src={ThroneIcon} alt='' className='w-6 lg:w-8 -ml-[1px]' />
      </>
    ),
    url: THRONE_URL,
    background: { background: '#25D366' },
  },
];

export const smallPayPins = [
  {
    serviceName: 'Cashapp',
    icon: <SiCashapp />,
    url: CASH_APP_URL,
    background: { background: '#000' },
  },
  {
    serviceName: 'Throne',
    icon: (
      <>
        <img src={ThroneIcon} alt='' className='w-8 lg:w-10 -ml-[1px]' />
      </>
    ),
    url: THRONE_URL,
    background: { background: '#25D366' },
  },
];
